import React, { useState } from 'react';
import { AlarmClockIcon, CalendarPlusIcon, PencilIcon } from 'lucide-react';
import { formatDate } from '../../utils/conditions';
interface InlineDateFieldProps {
  value?: string;
  onSave: (value: string | undefined) => void;
  ariaLabel: string;
  emptyLabel: string;
  tone?: 'default' | 'success' | 'danger';
}
export function InlineDateField({
  value,
  onSave,
  ariaLabel,
  emptyLabel,
  tone = 'default'
}: InlineDateFieldProps) {
  const [editing, setEditing] = useState(false);
  if (editing) {
    return <input type="date" autoFocus defaultValue={value} aria-label={ariaLabel} onBlur={e => {
      onSave(e.target.value || undefined);
      setEditing(false);
    }} onKeyDown={e => {
      if (e.key === 'Enter') e.currentTarget.blur();
      if (e.key === 'Escape') setEditing(false);
    }} className="w-full rounded-md border border-brand px-1.5 py-1 text-xs text-slate-800 focus:outline-none focus:ring-1 focus:ring-brand" data-id="element-214" data-mp="3w8prqqrpzhh" />;
  }
  if (!value) {
    return <button type="button" onClick={() => setEditing(true)} aria-label={`${ariaLabel}: not set`} className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-dashed border-slate-300 px-2 py-1 text-xs font-medium text-slate-500 transition-colors hover:border-brand hover:text-brand focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-215" data-mp="3vy5m7kfelc6i">
        <CalendarPlusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-216" data-mp="iizfqbywmdin" />
        {emptyLabel}
      </button>;
  }
  return <button type="button" onClick={() => setEditing(true)} aria-label={`${ariaLabel}: ${formatDate(value)}. Edit`} className={`group inline-flex items-center gap-1.5 whitespace-nowrap rounded text-sm tabular-nums focus:outline-none focus-visible:ring-2 focus-visible:ring-brand ${tone === 'danger' ? 'bg-red-50 px-1.5 py-0.5 font-semibold text-red-700 ring-1 ring-inset ring-red-200 hover:bg-red-100' : `-mx-1 px-1 py-0.5 hover:bg-slate-100 ${tone === 'success' ? 'text-steel' : 'text-slate-700'}`}`} data-id="element-217" data-mp="njdfl6qcqh5l">
      {tone === 'danger' && <AlarmClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-218" data-mp="9itceymsqzys" />}
      {formatDate(value)}
      <PencilIcon className="h-3 w-3 text-slate-400 opacity-0 transition-opacity group-hover:opacity-100" aria-hidden="true" data-id="element-219" data-mp="5fn6js3ljasu" />
    </button>;
}